import React, { FC, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useUnit } from 'effector-react';
import {
  $dynamicObjectExportAccess,
  checkDynamicObjectExportAccessFx,
} from './accessModel';
import NotFound from '../../../pages/errors/NotFound';

export const DynamicObjectExportAccessGuard: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [access, pending] = useUnit([
    $dynamicObjectExportAccess,
    checkDynamicObjectExportAccessFx.pending,
  ]);



  if (access === null || pending) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        p={3}
      />
      
    );
  }

  if (!access) {
    return (
      <NotFound />
        
    );
  }

  return <>{children}</>;
};

